module.exports = __webpack_public_path__ + "img/glyphicons-halflings-regular.32941d63.svg";